"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDropShortLinksMappingReport = void 0;
const endpointIds_1 = require("root/src/shared/descriptions/endpoints/endpointIds");
const lenses_1 = require("root/src/shared/descriptions/endpoints/lenses");
const getDaresReportPayloadSchema_1 = __importDefault(require("root/src/shared/descriptions/endpoints/schemas/requestSchemas/getDaresReportPayloadSchema"));
const auth_1 = require("root/src/shared/constants/auth");
const payloadSchema = getDaresReportPayloadSchema_1.default;
exports.getDropShortLinksMappingReport = {
    [endpointIds_1.GET_DROP_SHORT_LINKS_MAPPING_REPORT]: {
        authentication: auth_1.authenticationTypes.authenticated,
        authenticationRole: auth_1.userGroups.brand,
        endpointType: lenses_1.otherEndpointType,
        payloadSchema,
    },
};
